import { render, staticRenderFns } from "./setJf.vue?vue&type=template&id=7a27078d&scoped=true&"
import script from "./setJf.vue?vue&type=script&lang=js&"
export * from "./setJf.vue?vue&type=script&lang=js&"
import style0 from "./setJf.vue?vue&type=style&index=0&id=7a27078d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a27078d",
  null
  
)

export default component.exports